import PropTypes from 'prop-types';
import { Box } from '@mui/material';

/**
 * Txt — texto da /integrations IMUNE ao shrink global de tipografia.
 *
 * O tema (App.jsx) encolhe as fontes abaixo de 600px via `@media (max-width:600px)`
 * nas variantes do MUI (body1/h4/etc.). Isso sobrescreve o `fontSize` do `sx` no mobile,
 * quebrando as proporções do mockup. `Txt` renderiza um `Box` (sem variante MuiTypography),
 * então o `fontSize` definido vale igual em mobile e desktop — fiel ao HTML da designer.
 *
 * Use no lugar de <Typography> em toda a /integrations.
 */
export default function Txt({ component = 'div', sx, children, ...rest }) {
  return (
    <Box component={component} sx={{ m: 0, ...sx }} {...rest}>
      {children}
    </Box>
  );
}

Txt.propTypes = {
  component: PropTypes.elementType,
  sx: PropTypes.object,
  children: PropTypes.node,
};
